import { Card, Input, Space, Tag } from 'antd';
import React from 'react';

import Text from '@/atoms/Text';

export interface FreeTextFieldsCardProps {
  accomplishments?: string;
  planNextWeek?: string;
  risksBlockers?: string;
  onFieldsChange?: (fields: {
    accomplishments?: string;
    planNextWeek?: string;
    risksBlockers?: string;
  }) => void;
  disabled?: boolean;
}

export function FreeTextFieldsCard({
  accomplishments = '',
  planNextWeek = '',
  risksBlockers = '',
  onFieldsChange,
  disabled = false,
}: Readonly<FreeTextFieldsCardProps>): React.ReactElement {
  const handleAccomplishmentsChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onFieldsChange?.({
      accomplishments: e.target.value,
      planNextWeek,
      risksBlockers,
    });
  };

  const handlePlanChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onFieldsChange?.({
      accomplishments,
      planNextWeek: e.target.value,
      risksBlockers,
    });
  };

  const handleRisksChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onFieldsChange?.({
      accomplishments,
      planNextWeek,
      risksBlockers: e.target.value,
    });
  };

  return (
    <Card variant="borderless" className="free-text-fields-card">
      <Space direction="vertical" size="large" className="free-text-fields-card__full-width">
        <div className="card__header">
          <div>
            <Text variant="h5" as="span">
              Free-Text Fields
            </Text>
            <Tag className="free-text-fields-card__optional-tag">Optional</Tag>
          </div>
          <Tag className="card__source-tag">Source: Manual</Tag>
        </div>

        {/* Accomplishments Since Last Update */}
        <div>
          <label className="free-text-fields-card__field-label">
            <Text variant="bodyDefault" as="span">
              Accomplishments Since Last Update
            </Text>
            <span className="free-text-fields-card__optional">(optional)</span>
          </label>
          <Input.TextArea
            rows={3}
            placeholder="What landed since the last update?"
            className="free-text-fields-card__textarea"
            value={accomplishments}
            onChange={handleAccomplishmentsChange}
            disabled={disabled}
          />
        </div>

        {/* Plan for Next Week */}
        <div>
          <label className="free-text-fields-card__field-label">
            <Text variant="bodyDefault" as="span">
              Plan for Next Week
            </Text>
            <span className="free-text-fields-card__optional">(optional)</span>
          </label>
          <Input.TextArea
            rows={3}
            placeholder="What's the focus for next week?"
            className="free-text-fields-card__textarea"
            value={planNextWeek}
            onChange={handlePlanChange}
            disabled={disabled}
          />
        </div>

        {/* Risks & Blockers */}
        <div>
          <label className="free-text-fields-card__field-label">
            <Text variant="bodyDefault" as="span">
              Risks & Blockers
            </Text>
            <span className="free-text-fields-card__optional">(optional)</span>
          </label>
          <Input.TextArea
            rows={3}
            placeholder="Anything blocking progress or threatening dates?"
            className="free-text-fields-card__textarea"
            value={risksBlockers}
            onChange={handleRisksChange}
            disabled={disabled}
          />
        </div>
      </Space>
    </Card>
  );
}
